// External
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as htmlToImage from 'html-to-image';
import download from 'downloadjs';

// Internal
import DateManager from "general_utils/datemanager";
import { general_config } from 'general_utils/general_configuration';

export const graphLayout = (productNames, from, to, apiData) => {

  /*Clean code here */
  const datemanager = new DateManager();
  let allButtonClicked = false;
  let numDaysAllButton = 5001;
  let [_, allButtonFrom] = datemanager.getToFrom(numDaysAllButton);
  if (allButtonFrom === from) allButtonClicked = true;

  if (allButtonClicked) from = (apiData.length === 1 ? apiData[0]?.x[0] : (new Date(apiData[0]?.x[0]) < new Date(apiData[1]?.x[0]) ? apiData[0]?.x[0]: apiData[1]?.x[0]));
  let title = "";
  for (let product of productNames) (title.length === 0 ? title += " " + product : title += " & " + product)
  let dict = {
    legend: {
    x: 1,
    y: 5
  },
  plot_bgcolor:"#f1f3f4",
  paper_bgcolor:"#f1f3f4",
  hovermode: 'x unified',
  font: {
    family: "'Saira',Helvetica,Arial,Lucida,sans-serif"
  },
  title: {
    text: (productNames.length !== 0 & apiData[0]?.x.length>0 ? `${title?.toUpperCase()} GRAPH<br><sup>Comparison of ${title} from ${from} to ${to}</sup>` : ""),
    font: {
      color: '#000000',
    }
  },
  xaxis: {
    gridcolor: '#ffffff',
    autorange: true,
    tickformat: '%d %b %Y',
    hoverformat: '%d/%m/%Y',
    type: 'date',
  },
}

productNames.forEach((product, i) => {
      if (i === 0 ) { // first axis of all (by default, on the left)
        dict["yaxis" + ( i + 1)] = {
          title: { 
            text: (product !== undefined ? product?.toUpperCase() + " DATA IN " + general_config['products'][product.toUpperCase()]?.productMeasure.toUpperCase() : ""),
          },
          hoverformat: '.2f',
          color: general_config['products'][product.toUpperCase()]?.productColor,
          rangemode:"tozero",
          gridcolor: '#ffffff'
        } 
      }
      else if (i === 1) { // second axis on the right
        dict["yaxis" + ( i + 1)] = {
            title: { 
              text: (product !== undefined ? product?.toUpperCase() + " DATA IN " + general_config['products'][product.toUpperCase()]?.productMeasure.toUpperCase() : ""),
            },
            hoverformat: '.2f',
            overlaying: 'y',
            side: 'right',
            anchor: 'x',
            color: general_config['products'][product.toUpperCase()]?.productColor,
            rangemode:"tozero",
            gridcolor: '#ffffff'
          } 
        }
      else if (i%2 !== 0) { // nor first nor second axis and the division said it is uneven, so it goes to the right
      dict["yaxis" + ( i + 1)] = {
        title: { 
          text: (product !== undefined ? product?.toUpperCase() + " DATA IN " + general_config['products'][product.toUpperCase()]?.productMeasure.toUpperCase() : ""),
        },
          hoverformat: '.2f',
          overlaying: 'y',
          side: 'right',
          anchor: 'free',
          position: (-0.03 * i) + 1.03,
          color: general_config['products'][product.toUpperCase()]?.productColor,
          rangemode:"tozero",
          gridcolor: '#ffffff'
        } 
      }
      else { // not first nor second axis and even, so it goes to the left
        dict["yaxis" + ( i + 1)] = {
          title: { 
            text: (product !== undefined ? product?.toUpperCase() + " DATA IN " + general_config['products'][product.toUpperCase()]?.productMeasure.toUpperCase() : ""),
          },
          hoverformat: '.2f',
          overlaying: 'y',
          side: 'left',
          anchor: 'free',
          position: 0.03 * i,
          color: general_config['products'][product.toUpperCase()]?.productColor,
          rangemode:"tozero",
          gridcolor: '#ffffff'
      }
    }
})

  return dict
    
}

export const graphConfiguration = () => {
  return {
    modeBarButtonsToRemove: ['autoScale2d', 'select2d', 'lasso2d', 'toImage']
  }
};

export const exportPDF = (divId, fileName) => {
  const input = document.getElementById(divId)
  html2canvas(input, { loggin: true, letterRendering: 1, useCORS: true }).then(canvas => {
    const imgWidth = 208;
    const imgHeight = canvas.height * imgWidth / canvas.width;
    const imgData = canvas.toDataURL('img/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.save(fileName);
  })
}

export const exportPNG = (divId, fileName) => {
  htmlToImage.toPng(document.getElementById(divId))
    .then(function (dataUrl) {
      download(dataUrl, fileName);
    });
}

export const exportJPEG = (divId, fileName) => {
  htmlToImage.toJpeg(document.getElementById(divId))
    .then(function (dataUrl) {
      download(dataUrl, fileName);
    });
}

export const exportSVG = (divId, fileName) => {
  htmlToImage.toSvg(document.getElementById(divId))
    .then(function (dataUrl) {
      download(dataUrl, fileName);
    });
}

export const exportGraph = (divId, fileName, format) => {
  switch (format) {
    case 'PDF':
      const input = document.getElementById(divId)
      html2canvas(input, { loggin: true, letterRendering: 1, useCORS: true }).then(canvas => {
        const imgWidth = 208;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        const imgData = canvas.toDataURL('img/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.save(fileName);
      })
      break;
    case 'PNG':
      htmlToImage.toPng(document.getElementById(divId))
        .then(function (dataUrl) {
          download(dataUrl, fileName);
        });
      break;
    case 'JPEG':
      htmlToImage.toJpeg(document.getElementById(divId))
        .then(function (dataUrl) {
          download(dataUrl, fileName);
        });
      break;
    case 'SVG':
      htmlToImage.toSvg(document.getElementById(divId))
        .then(function (dataUrl) {
          download(dataUrl, fileName);
        });
      break;
    case 'REPORT':
        const input2 = document.getElementById(divId)
        html2canvas(input2, { 
          background: '#4554f5',
          loggin: true, 
          letterRendering: 1, 
          useCORS: true 
        }).then(canvas => {
          const imgWidth = 208;
          const imgHeight = canvas.height * imgWidth / canvas.width;
          const imgData = canvas.toDataURL('img/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          pdf.setDrawColor(0);
          pdf.setFillColor(69,84,245);
          pdf.rect(0, 0, canvas.width, canvas.height, 'F');
          pdf.setTextColor(255,255,255);
          pdf.addFont('Saira');
          pdf.setFont('Saria');
          pdf.text("This is the Wegaw report", 75, 10);
          pdf.addImage("data:image/jpeg;base64,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",
          "jpg", 50, 2, 20, 20);
          pdf.addImage(imgData, 'PNG', 12, 30, imgWidth*0.9, imgHeight*0.9);
          pdf.save(fileName);
        })
        break;
    default:
      alert("Invalid format");
  }
}